import { Component, Input } from '@angular/core';
import { NavController, NavParams, ToastController } from 'ionic-angular';
import { Globals } from "../../../globals";
import { CartaServices } from '../../carta/services';
import { QRServices } from '../../services/qrServices';
import { AddonsTriggerVersionProPage } from '../../addons/addons-trigger-version-pro/addons-trigger-version-pro';
import { TranslateService } from '@ngx-translate/core';
import { MenuServices } from '../../menu/services';
import { ComboServices } from '../../combo/services';
import { AnalyticsServices } from '../../services/analyticsServices';
import { HttpClient, HttpParams } from '@angular/common/http';

/**
 * Generated class for the ShareXxssPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'partial-share-xxss',
  templateUrl: 'share-xxss.html',
})
export class ShareXxssPage {

  @Input() type: string = "carta";
  @Input() style: string = "list";
  @Input() url: string = "";
  @Input() element_uid: string = "";
  @Input() xxss: any = {
    preview: true,
    whatsapp: true,
    twitter: true,
    facebook: true,
    instagram: true,
    email: true,
    copy: true,
    print: true,
    qr: true,
    xxss: true,
    download: true
  };

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public globals: Globals,
    private cartaServices: CartaServices,
    private qrServices: QRServices,
    public toastCtrl: ToastController,
    public translate: TranslateService,
    private menuServices: MenuServices,
    private comboServices: ComboServices,
    public analyticsServices: AnalyticsServices,
    public http: HttpClient) {
    if (this.navParams.get("type")) {
      this.type = this.navParams.get("type");
    }
    if (this.navParams.get("style")) {
      this.style = this.navParams.get("style");
    }
    if (this.navParams.get("url")) {
      this.url = this.navParams.get("url");
    }
    if (this.navParams.get("xxss")) {
      this.xxss = this.navParams.get("xxss");
    }
    if (this.navParams.get('modal')) {
      this.type = this.navParams.get('type');
      this.element_uid = this.navParams.get('element_uid');
    }
  }

  copy(str) {
    const el = document.createElement("textarea");
    el.value = str;
    el.setAttribute("readonly", "");
    el.style.position = "absolute";
    el.style.left = "-9999px";
    document.body.appendChild(el);
    const selected =
      document.getSelection().rangeCount > 0
        ? document.getSelection().getRangeAt(0)
        : false;
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
    if (selected) {
      document.getSelection().removeAllRanges();
      document.getSelection().addRange(selected);
    }
    this.shareTracking();
    //toast copiado
    let toast = this.toastCtrl.create({
      message: this.translate.instant('general-copiado'),
      duration: 1000,
      position: 'top'
    });
    toast.present();
  }

  print() {
    if (this.globals.checkLimitsByLicense('menus', 'print')) {
      this.analyticsServices.trackingExp('imprimir', this.globals.tracking_exp['print_element'], this.element_uid);
      if (this.type === 'carta') {
        this.globals.GAtrackView('Cartas', 'Cartas - Print', this.globals.restaurant.email, 'View', 'Print carta', 'Cartas', '');
        window.open(this.cartaServices.url_share_xxss + '&print=true', '_blank');
      } else if (this.type === 'menu') {
        this.globals.GAtrackView('Menu', 'Menu - Print', this.globals.restaurant.email, 'View', 'Print menu', 'Menu', '');
        window.open(this.menuServices.url_share_xxss + '&print=true', '_blank');
      } else if (this.type === 'combo') {
        this.globals.GAtrackView('Combo', 'Combo - Print', this.globals.restaurant.email, 'View', 'Print combo', 'Combo', '');
        window.open(this.comboServices.url_share_xxss + '&print=true', '_blank');
      } else {

      }
    } else {
      this.navCtrl.push(AddonsTriggerVersionProPage);
    }
  }

  qr() {
    this.analyticsServices.trackingExp('crear qr', this.globals.tracking_exp['create_qr'], this.element_uid);
    if (this.type === 'carta') {
      this.qrServices.generateMenuCartaGR(this.cartaServices.carta_tmp.UID, 'carta');
    } else if (this.type === 'menu') {
      this.qrServices.generateMenuCartaGR(this.menuServices.menu_tmp.UID, 'menu');
    } else if (this.type === 'combo') {
      this.qrServices.generateMenuCartaGR(this.menuServices.menu_tmp.UID, 'combo');
    } else {
      this.qrServices.generateMenuCartaListQr();
    }
  }

  shareAll() {
    this.shareTracking();
    if (this.type === 'carta') {
      this.globals.GAtrackView('Cartas', 'Cartas - Share', this.globals.restaurant.email, 'View', 'Share carta', 'Cartas', '');
      if (this.globals.so_mobile) {
        window.location.assign(this.cartaServices.url_share_xxss);
      } else {
        window.open(this.cartaServices.url_share_xxss, '_blank');
      }
    } else if (this.type === 'menu') {
      this.globals.GAtrackView('Menu', 'Menu - Share', this.globals.restaurant.email, 'View', 'Share menu', 'Menu', '');
      if (this.globals.so_mobile) {
        window.location.assign(this.menuServices.url_share_xxss);
      } else {
        window.open(this.menuServices.url_share_xxss, '_blank');
      }
    } else if (this.type === 'combo') {
      this.globals.GAtrackView('Combo', 'Combo - Share', this.globals.restaurant.email, 'View', 'Share combo', 'Combo', '');
      if (this.globals.so_mobile) {
        window.location.assign(this.comboServices.url_share_xxss);
      } else {
        window.open(this.comboServices.url_share_xxss, '_blank');
      }
    }
  }

  shareTracking() {
    this.analyticsServices.trackingExp('compartir', this.globals.tracking_exp['share'], this.element_uid);
  }

  downloadWord() {
    let uid = '';
    if (this.type === 'carta') {
      uid = this.cartaServices.carta_tmp.UID;
    } else {
      uid = this.menuServices.menu_tmp.UID;
    }
    const params = new HttpParams()
      .set('uid', uid)
      .set('lang', this.globals.restaurant.lang)
      .set('currency', this.globals.currency_symbol);
    this.http.post(this.globals.analytics_path + 'export/' + this.type, params, {}).subscribe(async response => {
      window.open(response.toString());
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/components/share-xxss/share-xxss.ts